export type OccasionRef = { id: string; name_en?: string | null; name_ar?: string | null };

/** URL slug of a venue occasion: its English name, or its id when there is none. */
export function occasionSlug(o: OccasionRef): string {
  const s = (o.name_en || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return s || o.id;
}

export function findOccasionBySlug<T extends OccasionRef>(list: T[], slug: string): T | null {
  const want = (slug || '').toLowerCase();
  return list.find((o) => occasionSlug(o) === want) ?? null;
}
